<template>
  <div class="services">
    <div class="container">
      <div class="card my-3">
        <div class="card-header bg-primary text-light">
          <h2 class="text-center my-3" id="titre-service"></h2>
        </div>
        <div class="card-body">
          <div class="row my-3">
            <div class="col-md-4">
              <label class="mt-3" for="wilayat"
                >choisissez une region
                <span id="chargement" class="text-primary"
                  >(Chargement ...)</span
                ></label
              >
              <select class="form-control" v-model="wilaya_choosen">
                <option value="choisissez une wilaya"
                  >choisissez une wilaya</option
                >
                <option v-for="w in wilaya" :value="w" :key="w['.key']">
                  {{ w }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="mt-3" for="baladiyat"
                >choisissez une commune
                <span id="chargement1" class="text-primary d-none"
                  >(Chargement ...)</span
                ></label
              >
              <select class="form-control" v-model="commune_choosen">
                <option value="choisissez une commune"
                  >choisissez une commune</option
                >
                <option :value="c" v-for="c in commune" :key="c">
                  {{ c }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="mt-3" for="specialites"
                >choisissez une specialite (optionnelle)</label
              >
              <select class="form-control" v-model="specialite_choosen">
                <option :value="null">choisissez une sepecialite</option>
                <option v-for="spec in specialite" :value="spec" :key="spec">{{
                  spec
                }}</option>
              </select>
            </div>
            <div class="col-md-12 my-3">
              <input
                class="btn btn-primary btn-block btn-lg"
                type="button"
                value="rechercher"
                @click="search_info()"
              />
            </div>
          </div>
          <!-- start accordian -->
          <div
            class="accordion"
            id="accordionExample"
            v-for="etab in etab_info"
            :key="etab.name"
          >
            <div
              v-if="is_loading"
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionExample"
            >
              <div class="card-body">
                <div class="text-center spinner text-primary">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <!-- start card  -->

                <!-- end card -->
              </div>
            </div>

            <div class="card">
              <div class="card-header text-center" id="headingOne">
                <h2 class="mb-0">
                  <button
                    class="btn btn-link collapsed"
                    type="button"
                    data-toggle="collapse"
                    :data-target="'#' + etab.key"
                    aria-expanded="true"
                    aria-controls=""
                    @click="set_extra_info(etab)"
                  >
                    {{ etab.name }}
                  </button>
                </h2>
              </div>
              <div
                :id="etab.key"
                class="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordionExample"
              >
                <div class="card-body text-center">
                  <div class="card mb-3" style="max-width: 100%;">
                    <div class="row no-gutters">
                      <div class="col-md-4">
                        <img
                          :src="
                            etab.image.slice(0, 5) == 'https'
                              ? etab.image
                              : require('@/assets/image/mm.jpg')
                          "
                          class="card-img img-fluid"
                          style="height: 100%;"
                          alt="..."
                        />
                      </div>
                      <div class="col-md-8">
                        <div class="card-body">
                          <p class="card-text">
                            {{ etab.description.substr(0, 70) }}
                            <a
                              id="readmore"
                              data-titre=""
                              data-text=""
                              href="#"
                              class="text-primary"
                              data-toggle="modal"
                              data-target="#exampleModalScrollable"
                              >lire la suite</a
                            ><br />
                            <b class="text-primary">adress</b>
                            <i
                              class="mx-2 far fa-address-book text-primary"
                              aria-hidden="true"
                            ></i
                            ><b>{{ etab.adress }} </b><br />
                            <b class="text-primary">Email</b>
                            <i
                              class="far fa-envelope mx-2 text-primary"
                              aria-hidden="true"
                            ></i
                            ><b>{{ etab.email }} </b><br />
                            <b class="text-primary">Phone</b
                            ><i
                              class="fa fa-phone-square mx-2 text-primary"
                              aria-hidden="true"
                            ></i>
                            <b> {{ etab.phone }} </b><br />
                            <b class="text-info">{{ etab.specialte }}</b
                            ><br />
                          </p>

                          <p class="card-text">
                            <small class="text-muted">
                              ouvre à<i
                                class="mx-2 text-primary fa fa-hourglass-start"
                                aria-hidden="true"
                              ></i>
                              {{ etab.hStart }}
                              <b class="text-primary"> ** || ** </b>ferme à<i
                                class="mx-2 text-primary fa 
                                fa-hourglass-end"
                                aria-hidden="true"
                              ></i>
                              {{ etab.hEnd }} </small
                            ><br /><br />
                            <button
                              data-toggle="modal"
                              data-target=".bd-example-modal-xl"
                              type="button"
                              class="btn btn-primary"
                              @click="
                                set_position(etab.lognitude, etab.longitude)
                              "
                            >
                              sur le map
                              <i
                                class="fa fa-map-marker-alt mx-2 text-light"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalScrollable"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalScrollableTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="background-color:#000098;color:white;"
          >
            <h5 class="modal-title" id="exampleModalScrollableTitle">
              {{ extra_info.name }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" style="color:#fff;">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{ extra_info.description }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              style="background-color:#000098 !important;"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- extra large modal -->
    <div
      class="modal fade bd-example-modal-xl"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myExtraLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content" id="formap">
          <!-- start map -->
          <div id="map" class="map">
            <gmaps-map :options="mapOptions.mapOption">
              <gmaps-marker :options="mapOptions.p" />
            </gmaps-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { gmapsMap, gmapsMarker } from "x5-gmaps";

export default {
  components: { gmapsMap, gmapsMarker },
  data() {
    return {
      wilaya: [],
      commune: [],
      specialite: [],
      wilaya_choosen: null,
      commune_choosen: null,
      specialite_choosen: null,
      etab_info: [],
      routeP: this.$route.params.id,
      is_loading: false,
      extra_info: [],
      mapOptions: {
        mapOption: {
          center: { lat: 31, lng: 2 },
          zoom: 12
        },
        p: { position: { lat: 31, lng: 2 } }
      }
    };
  },
  mounted() {
    db.ref()
      .child("All_" + this.routeP)
      .orderByChild("wilaya")
      .on("child_added", e => {
        if (this.wilaya.indexOf(e.val().wilaya) == -1) {
          this.wilaya.push(e.val().wilaya);
        }
      });
    db.ref()
      .child("All_" + this.routeP)
      .orderByChild("wilaya")
      .on("child_added", e => {
        var sp = e.val().specialte.split(",");
        sp.forEach(v => {
          if (this.specialite.indexOf(v) == -1 && v != "") {
            this.specialite.push(v);
          }
        });
      });
  },
  watch: {
    wilaya_choosen: function() {
      console.log("updated");
      this.commune = [];
      db.ref()
        .child("All_" + this.routeP)
        .orderByChild("wilaya")
        .on("child_added", e => {
          if (this.wilaya_choosen == e.val().wilaya) {
            if (this.commune.indexOf(e.val().commute) == -1) {
              this.commune.push(e.val().commute);
            }
          }
        });
    }
  },
  methods: {
    search_info() {
      var self = this;
      self.etab_info = [];
      // self.is_loading = true;
      db.ref()
        .child("All_" + this.routeP)
        .on("child_added", function(e) {
          if (
            (self.specialite_choosen == null &&
              e.val().wilaya == self.wilaya_choosen &&
              e.val().commute == self.commune_choosen) ||
            (e.val().wilaya == self.wilaya_choosen &&
              e.val().commute == self.commune_choosen &&
              self.specialite_choosen == e.val().specialte)
          ) {
            self.etab_info.push(e.val());
          }
        });
    },
    set_extra_info(data) {
      this.extra_info = data;
    },
    set_position(latitude, longitude) {
      this.mapOptions.mapOption = {
        center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
        zoom: 12
      };
      this.mapOptions.p = {
        position: {
          lat: parseFloat(latitude),
          lng: parseFloat(longitude)
        }
      };
    }
  }
};
</script>



<style lang="scss" scoped>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  overflow-x: hidden;
}

.a {
  height: 500px;
  margin-top: 50px;
}

#formap {
  background: #000098;
  height: 90vh;
}

#map {
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 10px;
  border: 4px solid white;
}

#accordionExample .card-header {
  background-color: rgb(0, 0, 152);
}

#accordionExample .btn-link {
  color: #ffffff !important;
}

#accordionExample button:hover {
  color: #ffffff;
}
</style>